import { Fragment } from 'react';

import { UserIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@repo/ui/components/common';

import { usePortalUrls } from '@/client/hooks/portal.hooks';
import { useUser } from '@/client/hooks/user.hooks';

export const UserButton = () => {
  const { t } = useTranslation();
  const user = useUser();

  const { portalUrl, loginUrl, logoutUrl } = usePortalUrls();

  const displayName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(' ') || user.username
    : null;

  return (
    <DropdownMenu modal>
      <DropdownMenuTrigger asChild>
        <Button
          aria-label={t('user.myAccount')}
          variant="ghost"
          className="hover:bg-white"
          data-testid="user-button"
          data-user-state={user ? 'authenticated' : 'anonymous'}
        >
          <UserIcon className="size-6" />
          {user ? (
            <span className="hidden items-center gap-1 md:inline-flex">
              <span>{t('common.hello')}</span>
              <span className="font-bold">{displayName}</span>
            </span>
          ) : (
            <span className="hidden items-center gap-1 md:inline-flex">{t('user.myAccount')}</span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="border-none px-2 py-3 shadow-2xl" side="bottom" align="start">
        <DropdownMenuLabel className="font-bold">
          {user ? displayName : t('user.myAccount')}
        </DropdownMenuLabel>
        <DropdownMenuGroup>
          {user ? (
            <Fragment>
              <DropdownMenuItem asChild>
                <a href={portalUrl} className="block w-full cursor-pointer">
                  {t('user.openPortal')}
                </a>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <a href={logoutUrl} className="block w-full cursor-pointer">
                  {t('user.logout')}
                </a>
              </DropdownMenuItem>
            </Fragment>
          ) : (
            <DropdownMenuItem asChild>
              <a href={loginUrl} className="block w-full cursor-pointer">
                {t('user.login')}
              </a>
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
